import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-section {
  gap: ${dt('appSection.gap')};

  & .header {
    background: ${dt('appSection.header.background')};
    padding: ${dt('appSection.header.padding')};

    & span {
      font-size: ${dt('appSection.header.fontSize')};
      font-weight: ${dt('appSection.header.fontWeight')};
      line-height: ${dt('appSection.header.lineHeight')};
    }
  }

  & .content {
    padding: 0px;
  }
}
`;
